import React, { useEffect } from "react";
import "./Team.css";

export default function Team() {
  useEffect(() => {
    document.title = "Our Team | Gifted Child Therapy";
  }, []);

  return (
    <div className="team-page container my-5">
      <h2 className="page-heading text-center mb-5">Our Team</h2>

      <div className="row g-4">
        {/* Team Member 1 */}
        <div className="col-md-4">
          <div className="team-card">
            <img src="/team/occupational.png" alt="occupationalTherapist" />
            <h5>Dr. Jabanal Preeti</h5>
            <p>Pediatric Occupational Therapist</p>
          </div>
        </div>

         {/* Team Member 2 */}
        <div className="col-md-4">
          <div className="team-card">
            <img src="/team/seniorPhysiotherapist.png" alt="seniorPhysiotherapist" />
            <h5>Dr. Jacob Praveen</h5>
            <p>Senior Musculoskeletal Physiotherapist</p>
          </div>
        </div>

        {/* Team Member 3 */}
        <div className="col-md-4">
          <div className="team-card">
            <img src="/team/behavioural.png" alt="behaviouralTherapist" />
            <h5>S.Sharon Jesse</h5>
            <p>Behavioural Therapist</p>
          </div>
        </div>

        {/* Team Member 4 */}
        <div className="col-md-4">
          <div className="team-card">
            <img src="/team/specEdu.png" alt="specEduTherapist" />
            <h5>Pooja MS</h5>
            <p>Special Educator</p>
          </div>
        </div>

        {/* Team Member 5 */}
        <div className="col-md-4">
          <div className="team-card">
            <img src="/team/speechTherap.png" alt="speechTherapist" />
            <h5>Leema</h5>
            <p>Speech Therapist</p>
          </div>
        </div>

         {/* Team Member 6 */}
        <div className="col-md-4">
          <div className="team-card">
            <img src="/team/physio.png" alt="physiotherapist" />
            <h5>Dr. Narmadha</h5>
            <p>Physiotherapist</p>
          </div>
        </div>
      </div>
    </div>
  );
}
